export default "__VITE_ASSET__7387ca5a__"